import { generatePath } from '@ps/web-core-utils';
import type { HgClubInfo } from '@ps/web-shared-api-types/v0/SwHomeGames';
import { Link, Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import { isEmpty } from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import { select } from '@swf/core/store';

import { useHomeGamesWidget } from '../../../model';
import { UserClubRole } from '../../../types/common';

import { TXTWCL_All_Clubs } from './SidebarNav.messages.json';
import styles from './SidebarNav.scss';
import ClubItem from './SidebarNavClubItem';

const filterClubs = ({ roleForUser }: HgClubInfo) =>
  roleForUser !== UserClubRole.Confirmation && roleForUser !== UserClubRole.Suspended;

const SidebarNav = () => {
  const { widgetSelect } = useHomeGamesWidget();
  const { homeGamesClubs = '' } = useSelector(select.cms.getAliases);
  const clubs = useSelector(widgetSelect.clubs);
  const { pathname } = useLocation();

  return (
    <div className={styles.container}>
      <ul className={styles.nav}>
        <li
          className={classNames(styles.navItem, {
            [styles.active]: pathname === generatePath(homeGamesClubs, {})
          })}
        >
          <Link alias="homeGamesClubs">
            <Translation {...TXTWCL_All_Clubs} />
          </Link>
        </li>
        {!isEmpty(clubs) && (
          <>
            {clubs.filter(filterClubs).map((club, index) => (
              <li
                key={club.clubId}
                className={classNames(styles.subNavItem, {
                  [styles.active]: pathname.includes(`${club.clubId}`)
                })}
              >
                <ClubItem club={club} index={index} />
              </li>
            ))}
          </>
        )}
      </ul>
    </div>
  );
};

export default SidebarNav;
